import PayItemSelect from '../../../../CIMSSelect/common/PayItemSelect'
import { useCIMSTableContext } from '../../../CIMSTableContext'

function PayItemsHeaderSelect<T extends object>() {
  const { actions } = useCIMSTableContext<T>()
  const { globalId, onChange } = actions.header.payItems ?? {}
  return (
    <PayItemSelect
      simple
      value={globalId}
      showLabel
      onChange={(value) => onChange?.(value as string)}
      style={{ width: 'max(25vw, 300px)' }}
    />
  )
}

export default PayItemsHeaderSelect
